import React from 'react'
import { Flex, Text, Table, Loading } from '@workwhile/ui'
import { useNotInterestedReasonsQuery } from 'queries/listings/useNotInterestedReasonsQuery'
import { formatNumber } from 'lib/number'

const columns = [
  {
    header: 'Reason',
    accessorKey: 'reason',
  },
  {
    header: 'Count',
    accessorKey: 'count',
    cell: ({ row }) => {
      return <Text textAlign="right">{formatNumber(row.original.count)}</Text>
    },
  },
]

type Props = {
  listingId: number
}

export const WorkerNotInterestedReasons = ({ listingId }: Props) => {
  const { data, isLoading } = useNotInterestedReasonsQuery(listingId)

  const reasons = data?.notInterestedReasons ?? []

  if (isLoading) {
    return (
      <Flex minHeight={80} justifyContent="center" alignItems="center">
        <Loading />
      </Flex>
    )
  }

  if (reasons.length === 0) {
    return (
      <Flex minHeight={120} justifyContent="center" alignItems="center">
        <Text fontSize={2}>No worker not interested reasons recorded.</Text>
      </Flex>
    )
  }

  return <Table columns={columns} data={reasons} />
}
